// rozpisUtil.js — spoločné drobnosti Rozpisu prác V3 (dni, farby, pruhy). Dátumy 'YYYY-MM-DD' v miestnom čase (utils/workdays.js).
import { parseISO, toISO, nextWorkDay, fmtDM } from '../../utils/workdays.js'
import { sviatok } from '../../utils/sviatky.js'

export const DN = ['Po', 'Ut', 'St', 'Št', 'Pi', 'So', 'Ne']
export const REMESLA = ['omietky', 'potery', 'malby', 'hodinovkari', 'ine']
export const REMESLO_LBL = { omietky: 'omietky', potery: 'potery', malby: 'maľby', hodinovkari: 'hodinovkári', ine: 'ostatné' }
export const dow = (iso) => (parseISO(iso).getDay() + 6) % 7
export const isWe = (iso) => dow(iso) >= 5
export const jeVolno = (iso) => isWe(iso) || !!sviatok(iso)
export const addDays = (iso, n) => { const d = parseISO(iso); d.setDate(d.getDate() + n); return toISO(d) }
export const mondayOf = (iso) => addDays(iso, -dow(iso))
export const dfull = (iso) => DN[dow(iso)] + ' ' + fmtDM(iso)
export const plural = (n, a, b, c) => (n === 1 ? a : (n >= 2 && n <= 4 ? b : c))
export function isoWeek(iso) { const d = parseISO(iso); const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())); const day = t.getUTCDay() || 7; t.setUTCDate(t.getUTCDate() + 4 - day); const y0 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1)); return Math.ceil(((t - y0) / 86400000 + 1) / 7) }
export function daysOf(view, weekStart) {
  if (view === 'tyzden') return Array.from({ length: 7 }, (_, i) => addDays(weekStart, i))
  const thu = addDays(weekStart, 3); const y = parseISO(thu).getFullYear(), m = parseISO(thu).getMonth()
  const out = []; for (let d = new Date(y, m, 1); d.getMonth() === m; d.setDate(d.getDate() + 1)) out.push(toISO(d)); return out
}
// Celý rok ako jeden pás (Mirko 1. 10. 2026: „potrebujem skrolovať cely rok"). Pohľad Týždeň/Mesiac
// je PRIBLÍŽENIE, nie okno — dni sú vždy všetky, mení sa len šírka stĺpca.
export function dniRoka(rok) {
  const out = []; const r = Number(rok)
  for (let d = new Date(r, 0, 1); d.getFullYear() === r; d.setDate(d.getDate() + 1)) out.push(toISO(d))
  return out
}
export const MESIACE = ['január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl', 'august', 'september', 'október', 'november', 'december']
// Farby stavov podľa Mirka (2. 10. 2026): „Prebiehajúcu zákazku zvýrazni viac, vždy to bolo zelenou.
// Plánovaná bola svetlo modrá a ukončená červená — ale zvýraznené naozaj ihneď na pohľad jasné."
// Výplň bloku ostáva farbou ZÁKAZKY, stav nesie rámik a popis (ústava 103.C) — inak sa stratí, ktorá zákazka je ktorá.
export const STAV = { planned: { l: 'Dohodnuté', c: '#0ea5e9' }, ongoing: { l: 'Prebieha', c: '#15803d' }, done: { l: 'Ukončené', c: '#dc2626' }, vacation: { l: 'Dovolenka', c: '#94a3b8' } }
export const stav = (s) => STAV[s === 'completed' ? 'done' : s] || STAV.planned
const PROJ_PAL = ['#7c3aed', '#0891b2', '#b45309', '#be123c', '#4d7c0f', '#0369a1', '#a16207', '#15803d', '#9333ea', '#0f766e', '#c2410c', '#1d4ed8', '#7e22ce', '#334155', '#3f6212', '#1e40af']
export const NOCODE = '#475569'
export function projColor(rec) {
  if (!rec || rec.status === 'vacation') return '#94a3b8'
  if (!rec.project_id) return NOCODE
  const key = String(rec.project_id); let h = 0; for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0
  return PROJ_PAL[h % PROJ_PAL.length]
}
export function hexA(hex, a) { const n = parseInt(String(hex).slice(1), 16); return `rgba(${n >> 16},${(n >> 8) & 255},${n & 255},${a})` }
// Zápis nemá začínať ani končiť cez víkend alebo sviatok (Mirko 6. 10. 2026: „oprav, víkendy sa nerobí").
// Vráti orezaný rozsah, alebo null, keď v ňom nie je ani jeden pracovný deň.
export function naPracovneDni(od, do_) {
  if (!od) return null
  let s = od, e = do_ || od
  let maPracovny = false
  for (let d = s; d <= e; d = addDays(d, 1)) if (!jeVolno(d)) { maPracovny = true; break }
  if (!maPracovny) return null
  while (jeVolno(s)) s = addDays(s, 1)
  while (jeVolno(e)) e = addDays(e, -1)
  return (s > e) ? null : { od: s, do: e, zmenene: s !== od || e !== (do_ || od) }
}
export const nazov = (r) => r.projectName || r.project_name || (r.project_id ? String(r.project_id) : '?')
// súvislé pruhy: záznam → i0..i1 v rámci dní; „lane“ = poradie pri prekryve (stabilné podľa začiatku)
export function lanesFor(recs, days) {
  const n = days.length; const items = []
  const sorted = recs.slice().sort((a, b) => (a.start_date < b.start_date ? -1 : a.start_date > b.start_date ? 1 : String(a.id).localeCompare(String(b.id))))
  for (const r of sorted) {
    let i0, i1
    // Čakací list má po novom TERMÍN (Mirko 1. 10. 2026) — kreslí sa podľa dátumov ako každá iná
    // zákazka. Cez celý rozsah sa ťahá len zápis BEZ dátumov (zvyšok spred tej zmeny).
    if (r._bez_terminu) { i0 = 0; i1 = n - 1 } else { i0 = days.findIndex(d => d >= r.start_date); i1 = -1; days.forEach((d, i) => { if (d <= r.end_date) i1 = i }); if (i0 < 0 || i1 < i0) continue }
    let lane = 0; const used = items.filter(x => x.i0 <= i1 && x.i1 >= i0).map(x => x.lane); while (used.includes(lane)) lane++
    items.push({ r, i0, i1, lane })
  }
  return items
}
// v4 (Mirko 29. 9.: „ak je zákazka daná na počet dní — víkendy neoznačuj"): jeden zápis sa kreslí ako súvislé PRACOVNÉ úseky,
// blok sa cez víkend a sviatok neťahá. `prvy` = prvý úsek zápisu (nesie meno stavby, ďalšie majú ↩).
export function segsOf(items, days) {
  const out = []; const videl = {}
  for (const it of items) {
    if (it.r._bez_terminu) { out.push({ ...it, prvy: true }); continue }
    let i = it.i0
    while (i <= it.i1) {
      if (jeVolno(days[i])) { i++; continue }
      let j = i; while (j + 1 <= it.i1 && !jeVolno(days[j + 1])) j++
      out.push({ r: it.r, lane: it.lane, i0: i, i1: j, prvy: !videl[it.r._id || it.r.id] }); videl[it.r._id || it.r.id] = 1; i = j + 1
    }
  }
  return out
}
export const nextWork = nextWorkDay
